import { useTranslation } from 'react-i18next';
import Text from '~/components/typographies/Text';
import IconAlertTriangle from '~/icons/icon-alert-triangle-fill.svg?react';
import styles from './ErrorScreen.module.scss';

interface Props {
  message?: string;
}

export default function ErrorScreen({ message }: Props) {
  const { t } = useTranslation('not_found', { keyPrefix: 'error_screen' });

  return (
    <div className={styles.root}>
      <IconAlertTriangle className={styles.icon} />
      <Text variant="body1" weight="regular" className={styles.message}>
        {message ?? t('message')}
      </Text>
    </div>
  );
}
